export const siteConfig = {
  name: "JournAI",
  url: "https://journai.vercel.app",
  ogImage: "https://magicui.design/og",
  description: "AI Journal App for smarter journaling.",
  links: {
    // twitter: "https://twitter.com/magicuidesign",
    // discord: "https://discord.gg/87p2vpsat5",
    github: "https://github.com/mainak9163/JournAI",
    // instagram: "https://instagram.com/magicuidesign/",
  },
  keywords: ["Journal", "AI Chat", "Sentiment Analsysis", "AI Summary", "Sentiment Score", "Open Source"],
};

export type SiteConfig = typeof siteConfig;
